import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({});
